import React, { useEffect } from "react";
import { Element } from "react-scroll/modules";
import { connect } from "react-redux";

import useProductTour, {
  PRODUCT_TOUR_STEP_IDS
} from "../../states/tour/tours/product";

import Optimized from "../optimized/Optimized";
import Stops from "./Stops";
import Vehicles from "./Vehicles";

function ProjectBody(props) {
  const {
    stopsCount,
    tabValue,
    setExpanded,
    currentWindow,
    isOptimized,
    selectedRoutes,
    showingRouteId,
    isRoutesSearchMode,
    isStopSelectOrSearchMode,
    solution
  } = props;

  const productTour = useProductTour();
  useEffect(() => {
    if (
      productTour.isTourStepId(
        PRODUCT_TOUR_STEP_IDS.PART_PUBLISH_AND_SHARE_STEP_BRIEF
      ) &&
      solution &&
      !solution.routes.some(route => route.stops.length > 2)
    ) {
      // alert("hi");
      productTour.cancelTour();
    }
  }, [solution, productTour]);

  return (
    <Element
      name="scroll-container"
      style={{
        height:
          !isOptimized ||
          tabValue === 2 ||
          selectedRoutes.length > 0 ||
          showingRouteId !== "" ||
          isRoutesSearchMode ||
          isStopSelectOrSearchMode
            ? "100vh"
            : solution.routes.some(route => route.stops.length > 2) 
            ? "calc(100vh - 200px)" 
            : "100vh",
        position: "relative",
        minHeight: "74px"
      }}
    >
      {tabValue === 0 && (
        <Stops stopsLength={stopsCount} optionsExpanded={false} />
      )}
      {tabValue === 1 && <Optimized currentWindow={currentWindow} />}
      {/* TODO: Remove me when vehicles moved to it's drawer */}
      {tabValue === 2 && (
        <Vehicles setExpanded={setExpanded} optionsExpanded={false} />
      )}
    </Element>
  );
}

function mapStateToProps(state) {
  return {
    tabValue: state.common.projectTabValue,
    isOptimized: state.project.solution,
    selectedRoutes: state.common.selectedRoutes,
    showingRouteId: state.project.showingRouteId,
    isRoutesSearchMode: state.common.isRoutesSearchMode,
    isStopSelectOrSearchMode:
      state.common.isStopSearchMode || state.common.isStopSelectMode,
    solution: state.project.solution
  };
}

export default connect(mapStateToProps)(ProjectBody);
